// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2O3wN","requiredAsterisk":"Info_requiredAsterisk__11U-b"};